import React from 'react';
import YoutubeLogo from '../../../assets/images/youtube_logo.png';
import ComingSoon from './ComingSoon';
import { IoIosPlayCircle } from 'react-icons/io';

const Text = ({ block, isVideoExplanation }) => {
  if (!block.body) {
    return <ComingSoon />;
  }

  if (isVideoExplanation) {
    if (block.body.includes('youtube.com')) {
      return (
        <div className="document-icon-container">
          <img
            src={YoutubeLogo}
            onClick={() => window.open(block.body, '_blank')}
            className="category-option-image"
            alt="Category option"
          />
        </div>
      );
    }
    return (
      <div className="document-icon-container">
        <IoIosPlayCircle
          onClick={() => window.open(block.body, '_self')}
          className="category-option-image"
          alt="Category option"
          color="#FD99C5"
          size={35}
          style={{ cursor: 'pointer' }}
        />
      </div>
    );
  }

  return <div dangerouslySetInnerHTML={{ __html: block.body }} />;
};

export default Text;
